export default status => {
  if (status === 'CREATED') {
    return '#e2e2e2';
  } if (status === 'SUCCEEDED') {
    return '#ececff';
  } if (status === 'EXPIRED') {
    return '#ee6972';
  } return '#e2e2e2';
};
